export default "<p>deliverable-info works!</p>\n";